import {WeekSchedule} from "./WeekSchedule";
import type {TacticalPlanResponseType} from "../components/TacticalPlan/TacticalPlanApi";
import type {TacticalPlanRuleResponseType} from "../components/TacticalPlan/TacticalPlanRuleApi";
import type {TacticalPlanRule} from "../components/TacticalPlan/TacticalPlanRule";


export function filterOnlyTacticalPlansForDay(tacticalPlans: TacticalPlanResponseType[], day: string) {
    return tacticalPlans
        .filter(tp=> WeekSchedule.isChecked(tp.week_schedule, WeekSchedule.getBitSumForDate(day) ))
        .map( (tp) => {
            return {
                id: tp.id && tp.id.toString() || '',
                label: `${tp.name}` // #${tp.id} - ${tp.name}
            }
        })
}


export function reorderRules(order: number[], tacticalPlanRules: TacticalPlanRule[]) {
    let newTacticalPlanRules: TacticalPlanRule[] = [];

    newTacticalPlanRules = order.map((i) => tacticalPlanRules[i]);
    if (order.length < tacticalPlanRules.length) {
        newTacticalPlanRules = newTacticalPlanRules.concat(tacticalPlanRules.slice(order.length));
    }

    newTacticalPlanRules.forEach( (rule, index) => {
        if (rule.getRule().priority>=0) { // dont change special last rule priority
            rule.getRule().priority = newTacticalPlanRules.length - index - 1;
        }
    })
    return newTacticalPlanRules;
}